import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e453a772&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=e453a772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e453a772",
  null
  
)

export default component.exports